var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTvVideo = _a => {
  var _b, _c, _d, _e, _f, _g, _h;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_4871_58)"
  }, React.createElement("path", {
    d: "M22.5217 19.3843C22.5217 19.9487 22.0817 20.4078 21.5174 20.4174H2.4826C1.91826 20.4174 1.47826 19.9487 1.47826 19.3843V6.01217C1.47826 5.44782 1.91826 4.98869 2.4826 4.97913H21.527C22.0913 4.97913 22.5313 5.44782 22.5313 6.01217V19.3843H22.5217Z",
    stroke: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.28087 20.4174V22.5217",
    stroke: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M19.7191 20.4174V22.5217",
    stroke: (_e = props.color) !== null && _e !== void 0 ? _e : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.09303 1.47827L12 4.98871L16.9069 1.47827",
    stroke: (_f = props.color) !== null && _f !== void 0 ? _f : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M19.0209 14.9174C18.9826 16.4287 17.7296 17.6244 16.2183 17.6052L7.80087 17.6244C6.28956 17.6626 5.03652 16.467 4.98869 14.9557V10.4887C5.01739 8.9774 6.27043 7.78175 7.78174 7.80088L16.1991 7.78175C17.7104 7.74349 18.9635 8.93914 19.0113 10.4504V14.9174H19.0209Z",
    stroke: (_g = props.color) !== null && _g !== void 0 ? _g : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4871_58"
  }, React.createElement("rect", {
    width: 22,
    height: 22,
    fill: (_h = props.color) !== null && _h !== void 0 ? _h : 'currentColor',
    transform: "translate(1 1)"
  }))));
};
export default SvgTvVideo;